import { z } from "zod";

export const autoApplyStatusSchema = z.enum([
  "pending",
  "approved",
  "submitting",
  "submitted",
  "failed",
  "skipped",
]);

export const targetPlatformSchema = z.enum([
  "linkedin",
  "indeed",
  "stepstone",
  "workday",
  "greenhouse",
  "lever",
  "xing",
  "karriere_at",
  "jobs_ch",
  "custom",
]);

export const autoApplyQueueItemSchema = z.object({
  id: z.string(),
  userId: z.string(),
  jobId: z.string(),
  resumeVariantId: z.string().nullable(),
  coverLetterId: z.string().nullable(),
  status: autoApplyStatusSchema,
  targetPlatform: z.string(),
  formData: z.unknown().nullable(),
  errorMessage: z.string().nullable(),
  submittedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const autoApplySettingsSchema = z.object({
  id: z.string(),
  userId: z.string(),
  dailyLimit: z.number().int().min(1).max(100),
  schedulingEnabled: z.boolean(),
  scheduleStartHour: z.number().int().min(0).max(23),
  scheduleEndHour: z.number().int().min(0).max(23),
  pauseUntil: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const queueJobInput = z.object({
  jobId: z.string(),
  resumeVariantId: z.string().optional(),
  coverLetterId: z.string().optional(),
  targetPlatform: z.string(),
});

export const updateSettingsInput = z.object({
  dailyLimit: z.number().int().min(1).max(100).optional(),
  schedulingEnabled: z.boolean().optional(),
  scheduleStartHour: z.number().int().min(0).max(23).optional(),
  scheduleEndHour: z.number().int().min(0).max(23).optional(),
  pauseUntil: z.string().nullable().optional(),
});

export type AutoApplyStatus = z.infer<typeof autoApplyStatusSchema>;
export type AutoApplyQueueItem = z.infer<typeof autoApplyQueueItemSchema>;
export type AutoApplySettings = z.infer<typeof autoApplySettingsSchema>;
export type QueueJobInput = z.infer<typeof queueJobInput>;
export type UpdateSettingsInput = z.infer<typeof updateSettingsInput>;
